import { Injectable } from '@angular/core';
import { Observable ,Subject} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class AccidentUserService {

  
  constructor(private http: HttpClient) { }

  getAccidentUser(data): Observable<any> {
    console.log("Adding data accident", data);
    let newdata = {}
    newdata['email'] = data;
    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "accident/user-list", newdata).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  /** ******************************************************************
   * add useraccident 
   */

  addAccidentUser(data) {


    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "accident-user", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });


  }



  editAccidentUser(data) {


    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.put(config.baseApiUrl + "accident-user", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });


  }

  updateAccidentUser(data) {


    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.put(config.baseApiUrl + "accident-user/updateUser", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log('response next...')
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });


  }


  /**
   * Delete Accident user From Single Accident 
   * *************************************************************
   */

  deleteAccidentUser(userData): Observable<any> {

    // console.log('Accident id here !!' + id + 'and user data here ' + data)

    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.delete(config.baseApiUrl + "accident/user?_id=" + userData).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  uploadProfilePhoto(data): Observable<any> {
    console.log("Getting Instructors");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "accident-user/userProfile", data).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data.instructors);
        observer.complete();
      })
    });
  }



}
